import errors from './errors.js';
import translation from './translation/index.js';
const zhCN = Object.freeze({
    translation,
    errors,
});
export default zhCN;
